export default function UserViewListController(
  $scope,
  $state,
  $filter,
  usersService,
  gettextCatalog,
) {
  'ngInject';

  //Local variables
  $scope.searchText = '';
  $scope.previousSearchText = '';
  $scope.unavailable = 'Unavailable';

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 10;
  $scope.maxSize = 3;

  //Sort filteredUserData
  $scope.orderBy = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
    GTM_ListChanges('usersOrderChanged');
  };

  //applyFilter searchs the userData[] for anything matching the search input.
  $scope.applyFilter = function (initialLoad) {
    if (
      !$scope.userData ||
      (typeof initialLoad === 'undefined' && $scope.previousSearchText === $scope.searchText)
    )
      return;
    $scope.filteredUserData = $filter('filter')($scope.userData, $scope.searchText);
    $scope.previousSearchText = $scope.searchText;
    GTM_ListChanges(
      typeof initialLoad === 'undefined'
        ? 'usersfiltered'
        : initialLoad
        ? 'usersLoaded'
        : 'usersRefreshed',
    );
  };

  var refresh = function (initialLoad = false) {
    $scope.loading = true;

    //general error handler.
    function handleError(error) {
      var errorMsg = gettextCatalog.getString(
        'An error occurred while retrieving user information',
      );
      if (error.data || error.status) {
        if (error.data.message) {
          errorMsg =
            error.data.message +
            ' ' +
            (error.status.toString() + ' - ' + error.statusText.toString());
        } else {
          errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
        }
      } else {
        errorMsg += gettextCatalog.getString('. Please try again later.');
      }
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = errorMsg;
    }

    //Get all users
    usersService
      .getUsers()
      .then(function (response) {
        $scope.userData = response.data;
        for (var i = 0; i < $scope.userData.length; i++) {
          if ($scope.userData[i].verified && !$scope.userData[i].password.isSet) {
            $scope.userData.splice(i, 1);
            i--;
          }
        }
        if ($scope.userData) {
          for (var i = 0; i < $scope.userData.length; i++) {
            $scope.userData[i].roles.data.sort(function (a, b) {
              var x = a.name.toLowerCase();
              var y = b.name.toLowerCase();
              if (x < y) {
                return -1;
              }
              if (x > y) {
                return 1;
              }
              return 0;
            });
            var concatData = [];
            for (var j = 0; j < $scope.userData[i].roles.data.length; j++) {
              concatData.push($scope.userData[i].roles.data[j].name);
            }
            $scope.userData[i].roles['concatData'] = concatData.join();
          }
        }
        $scope.applyFilter(initialLoad);
      }, handleError)
      .finally(function () {
        $scope.loading = false;
      });
  };

  $scope.pageChanged = function () {
    GTM_ListChanges('usersPageChanged');
  };

  function GTM_ListChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.userData.length,
        totalFiltered: $scope.filteredUserData.length,
        pageNumber: $scope.currentPage,
        orderBy: $scope.predicate,
        sortDirection: $scope.reverse ? 'descending' : 'ascending',
      },
    });
  }

  refresh(true);
}
